var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"}},_vm.$listeners),[_c('path',{attrs:{"d":"M2.5 10h15M2.5 5h15M2.5 15h15","stroke":"#262626","stroke-width":"1.667","stroke-linecap":"round","stroke-linejoin":"round"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }